import React from 'react'
import loadable from '@loadable/component'
import { ScreenSpinner } from '../../shared'

export const HomepageScreenLazy = loadable(() => import('./HomepageScreen'), {
  fallback: <ScreenSpinner />
})
